<template>
  <div class=" mt-28 lg:px-20 px-8">
      <h1 class=" font-mono text-4xl">Projects</h1>

    <content-loader v-if="!ready">
          <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
    <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
    <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
    <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
    <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
    <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
        </content-loader>

      <section class=" mt-6 space-y-6 font-mono">
            <div v-for="project in projects" :key="project.id" class=" border p-4">
          <h4 class=" text-sm">{{project.data.type}}</h4>
          <h3 class=" text-xl">{{project.data['project_title'][0].text}}</h3>

          <p class=" mt-4 text-sm text-gray-500">
              <prismic-rich-text :field="project.data.description"/>
          </p>

          <div class=" flex mt-6 space-x-4">
               <a class=" border border-gray-400 hover:bg-gray-100 text-xs px-4 py-3" :href="project.data['github_link'].url"><i class='bx bx-link-external' ></i>View on github</a>
               <router-link :to="{name: 'Project', query: {id: project.id}}" v-if="project.data.contains_article" class=" border border-gray-400 hover:bg-gray-100 text-xs px-4 py-3" href="#">Article</router-link>
          </div>
         
      </div>
      </section>

    
  </div>
</template>

<script>

import { ContentLoader } from 'vue-content-loader'
export default {
 components: {
    ContentLoader
  },
  data() {
    return {
      projects: [],
      ready: false
    }
  },
  methods: {
    getContent() {
      this.$prismic.client.query(this.$prismic.Predicates.at('document.type','project'))
      .then(response => {
          console.log(response)
        this.projects = response.results
        this.ready = true
      })
    }
  },
  created() {
    this.getContent()
  }
}
</script>

<style>

</style>